import {VehicleType} from '@app/vehicle/shared/vehicle-type';

export class VehicleBase {
  vehicleType: VehicleType;
  vrn: string;
  brand: string;
  model: string;
  type: string;
  color: string;
  color2: string;
  fuel: string;
  grossBpm: number; // Bruto BPM
  listPrice: number; // Catalogusprijs
  cylinderAmount: number;
  cylinderContents: number;
  typeApprovalNumber: number;
  placeChassisNumber: string;

  // Model specifics
  modelExecution: string;
  modelType: string;
  modelVariant: string;

  // Dates
  firstAdmissionDate: Date; // Datum eerste toelating
  firstIssueDate: Date; // Datum eerste afgifte
  expirationDateMOT: Date;

  // Weights
  curbWeight: number; // Massa rijklaar
  tareWeight: number; // Massa ledig voertuig
  technicalMaxMass: number;
  approvedMaxMass: number;
  maxMassComposition: number; // Maximum massa samenstelling
  maxMassPullWithBrake: number;
  maxMassPullWithoutBrake: number;
}
